import { call, put, takeEvery } from "redux-saga/effects";
import { mlThamSoPhongHocMonHocApi } from "../../../api/category/mlThamSoPhongHocMonHocApi";
import { IMLThamSoPhongHocMonHoc } from "../../../model/respone/category/IMLThamSoPhongHocMonHoc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eMLThamSoPhongHocMonHocActionIds,
  IMLThamSoPhongHocMonHocActionTypes,
} from "../../action-types/category/IMLThamSoPhongHocMonHocActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.mlThamSoPhongHocMonHoc;

export function* mlThamSoPhongHocMonHocSaga(): any {
  yield takeEvery(eMLThamSoPhongHocMonHocActionIds.LOAD_START, loadWorker);
  yield takeEvery(eMLThamSoPhongHocMonHocActionIds.SAVE_START, saveWorker);
  yield takeEvery(eMLThamSoPhongHocMonHocActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(mlThamSoPhongHocMonHocApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* saveWorker(action: IMLThamSoPhongHocMonHocActionTypes): any {
  const payload = action.payload as IMLThamSoPhongHocMonHoc;
  let res: IBaseRespone;
  // Risk 5: PK uppercase ID
  if (payload.ID > 0) {
    res = yield call(mlThamSoPhongHocMonHocApi.Update, payload);
  } else {
    res = yield call(mlThamSoPhongHocMonHocApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}
function* deleteWorker(action: IMLThamSoPhongHocMonHocActionTypes): any {
  const res: IBaseRespone = yield call(mlThamSoPhongHocMonHocApi.Delete, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
